import graphql from './graphql';

const query = /* GraphQL */ `
  query Module_list($courseId: ID!) {
    Module_list(courseId: $courseId) {
      id
      name
      isDraft
      order
    }
  }
`;

const ModuleList = async ({ courseId }) =>
  // eslint-disable-next-line camelcase
  graphql(query, { courseId }).then(({ Module_list }) => Module_list);

export default ModuleList;
